import React, { useState } from "react";
import cx from "clsx";

import globalStyles from "@/styles/global.module.scss";
import styles from "./imageButton.module.scss";

const ImageButton = props => {
  const { children, onClick } = props;

  const [isHovered, setIsHovered] = useState(false);
  const memoHover = val => () => setIsHovered(val);

  return (
    <div className={styles.container}>
      <button
        className={cx(
          globalStyles.buttonReset,
          globalStyles.modalButton,
          styles.button,
          isHovered && styles.isHovered
        )}
        onMouseOver={memoHover(true)}
        onFocus={memoHover(true)}
        onMouseOut={memoHover(false)}
        onBlur={memoHover(false)}
        onClick={onClick}
      >
        <div className={styles.buttonInner}>{children}</div>
      </button>
    </div>
  );
};

export default ImageButton;
